import { Component } from "react";
import Popup from "..";
import AppContext from "../../../contexts/AppContext";
import RectButton from "../../ui/button/RectButton";

import "./style.scss";

class ConfirmPopup extends Component {
    static contextType = AppContext;
    render() {
        return (
            <Popup className="confirm-poup">
                <div className="column">
                    <p>{this.props.message}</p>
                    <RectButton text="OK" onClick={()=>this.context.setPopup(null)} />
                </div>
            </Popup>
        )
    }
}

export default ConfirmPopup;